// T-325 — Etichetta user-facing del modello AI configurato per un tenant
// (da tenant_ai_config.default_provider). UNICA fonte: usata dalla Home (mobile)
// e rispecchiata nella dashboard admin con le STESSE etichette, così le due
// impostazioni non confliggono. Decisione owner (2026-06-29):
//   - default/free  → "TrackEAT IA"
//   - pro a pagamento → "TrackEAT IA PRO"
//   - qualsiasi altra scelta da dashboard → "Altro - <provider>"

export type AiModelKind = 'standard' | 'pro' | 'other';

// Provider "pro a pagamento" = i modelli Gemini 2.5 Pro (nativo o via OpenRouter).
const PRO_PROVIDERS = new Set<string>(['gemini_pro', 'openrouter_gemini_25_pro']);

// Provider "standard/free": il default e tutti i tier gratis/economici.
const STANDARD_PROVIDERS = new Set<string>([
  '',
  'gemini_flash',
  'openrouter_gemini_free',
  'openrouter_gemini_25_flash',
  'openrouter_gemini_25_flash_lite',
  'openrouter_qwen3_vl_30b',
  'openrouter_llama32_90b_vision',
  'openrouter_qwen25_vl_72b',
  'groq_llama_vision',
]);

export function aiModelKind(defaultProvider: string | null | undefined): AiModelKind {
  const p = (defaultProvider ?? '').trim();
  if (PRO_PROVIDERS.has(p)) return 'pro';
  if (STANDARD_PROVIDERS.has(p)) return 'standard';
  return 'other';
}

export function aiModelLabel(defaultProvider: string | null | undefined): string {
  const kind = aiModelKind(defaultProvider);
  if (kind === 'pro') return 'TrackEAT IA PRO';
  if (kind === 'standard') return 'TrackEAT IA';
  return `Altro - ${(defaultProvider ?? '').trim()}`;
}
